import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_kw6x2ac3kg: FaireBrandEntity = {
  token: "b_kw6x2ac3kg",
  type: "brand",
  name: "Dipped Shop",
  avatarUrl:
    "https://cdn.faire.com/fastly/6c4ad5685c77cefb8ebf75130d7ed627d1679cd37fa24ce9e7ba9b61d721472e.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/dc716637aa7149e087fcdfa5998d89ac5b9f2ceaa8136522364bf06a47f16efd.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/6c4ad5685c77cefb8ebf75130d7ed627d1679cd37fa24ce9e7ba9b61d721472e.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/dc716637aa7149e087fcdfa5998d89ac5b9f2ceaa8136522364bf06a47f16efd.jpeg",
  location: "vernon, CA, USA",
  minimumOrderDollars: 100,
  rating: 4.5,
  reviewCount: 152,
  isInsider: true,
  description:
    "Welcome to Dipped Shop!\n\nAt Dipped Shop, we make style accessible. Founded with a passion for the latest trends, we curate a collection of high-quality, trendy wholesale jewelry, hats, bags, accessories, gifts, and home goods. Our mission is to empower you to express your personal style with confidence.\n\nEach item in our store is handpicked for its quality and design. We collaborate with artisans and trusted suppliers to bring you unique, beautiful pieces. Whether you're searching for a statement necklace, a chic hat, a stylish bag, or a thoughtful gift, Dipped Shop has something for everyone.\n\nOur commitment to exceptional service ensures a seamless shopping experience. We value every customer and strive to make you feel satisfied with every purchase.\n\nThank you for choosing Dipped Shop. Explore our collection today and find the perfect additions to your wardrobe and home. Welcome to the Dipped Shop family!",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:46:08.906Z",
    importedBy: "entity-db-cli",
  },
};
